import { CompilerState, SAMPLE_REGISTRATION_TYPE } from '@/shared/types';
import { useWorkflowManager } from '@/shared/helpers/helpers';
import router from '@/router';

export enum ClinicalIndication {
  PRECONCEPTION = 'preconception',
  BREST_AND_OVARIAN_CANCER = 'brca',
  CHROMOSOMAL_ABNORMALITIES = 'cma',
  NON_INVASIVE_PRENATAL_SCREENING = 'nips',
}

export function getRainbowClinicalIndication(clinicalIndication): string {
  return (Object.keys(ClinicalIndication)[Object.values(ClinicalIndication).indexOf(clinicalIndication)] || clinicalIndication).toLowerCase();
}

export function getFriendlyInvitationType(): string {
  const accessSessionPayload = useWorkflowManager().compiler.getState as CompilerState;

  switch (accessSessionPayload.sampleRegistrationType) {
    case SAMPLE_REGISTRATION_TYPE.ACCESS_LINK_REGISTRATION:
      return 'Registration link';
    case SAMPLE_REGISTRATION_TYPE.ACCESS_MANUAL_REGISTRATION:
      return 'Access invite';
    case SAMPLE_REGISTRATION_TYPE.API_BULK_INVITATION:
      return 'API bulk';
    case SAMPLE_REGISTRATION_TYPE.API:
      return 'API';
    default:
      return 'Unknown';
  }
}

export function getFriendlyChannelType(): string {
  const accessSessionPayload = useWorkflowManager().compiler.getState as CompilerState;
  const resultsConfig = accessSessionPayload.appConfig === 'resultsConfig';

  if (resultsConfig) {
    return accessSessionPayload.personalInformation.email ? 'email' : 'sms';
  }

  return accessSessionPayload?.data['personal-details']?.personal_details_email ? 'email' : 'sms';
}

export function getFullAnalyticsRoutePath(): string {
  return router.currentRoute.value.fullPath.slice(1);
}
